import {
  GetMetricsDataParams,
  GetRealTimeDataParams,
  GetSortedMachineList,
  IRealTimeService,
  SortedMachineList
} from './contracts/realtime.service';
import {
  RealTimeMachineData,
  Metrics,
  LastMinuteMachineStatus
} from '_clean-code/types/realtime';

import apiClient from '../../api/index';
import { createUrl } from '_clean-code/utils/urlHelper';
import moment from 'moment';

const RealTimeService: IRealTimeService = {
  getRealTimeDataForMachines: async (
    params: GetRealTimeDataParams,
    metricsData: Metrics[]
  ) => {
    if (params.machineIds.length === 0) return [];
    const response = await apiClient.request(
      'GET',
      createUrl('/machines/realtime')
        .addQueryParamMany('machineId', params.machineIds)
        .addQueryParam('shift', params.shift)
        .addQueryParam(
          'start',
          params.day && moment(params.day).startOf('day').toDate().toISOString()
        )
        .addQueryParam(
          'end',
          params.day &&
            moment(params.day)
              .startOf('day')
              .add(1, 'day')
              .toDate()
              .toISOString()
        )
        .toStringUrl()
    );
    const data = response;
    return data.map(
      (x) =>
        ({
          ...x,
          oeeMetrics: x.metrics,
          metrics: {
            ...(metricsData.find(
              (metric) => metric.machineId === x.machineId
            ) ?? {}),
            ...x.metrics, // for single machine tv version
            oee_produced: x.metrics?.produced,
            oee_effectiveness: x.metrics?.effectiveness,
            oee_quality: x.metrics?.quality,
            oee_oee: x.metrics?.oee
          }
          // stops: x.stops.map((s) => ({ ...s, numberOfAlerts: 1 })),
        } as RealTimeMachineData)
    );
  },

  getSortedMachineList: async (params: GetSortedMachineList) => {
    const url = createUrl('/machines/list')
      .addQueryParam('sortBy', params.metric)
      .addQueryParam('type', params.sortType)
      .addQueryParamMany('machineId', params.machineId);

    const response = await apiClient.request('GET', url.toStringUrl());
    const data = response as SortedMachineList;

    return data;
  },

  getMachineMetrics: async (params: GetMetricsDataParams) => {
    const url = createUrl('/machines/metrics')
      .addQueryParam('days', params.noOfDays)
      .addQueryParamMany('machineId', params.machineIds);

    const response = await apiClient.request('GET', url.toStringUrl());
    const data = response as Metrics[];

    return data;
  },

  getLastMinuteMachinesStatus: async (
    machineGroupId: number
  ): Promise<LastMinuteMachineStatus[]> => {
    const response = await apiClient.request(
      'GET',
      createUrl('/v2/sensorReadings/get-last-minute-machines-status')
        .addQueryParam('machineGroupId', machineGroupId)
        .toStringUrl()
    );
    const data = response.data as LastMinuteMachineStatus[];

    return data;
  },

  getRealtimeDetail: async (
    machineId: number
  ): Promise<{
    productionBySku: {
      [skuId: string]: {
        skuId: string;
        total: number;
        defects: number;
        correct: number;
        scrap: number;
      };
    };
  }> => {
    const response = await apiClient.request(
      'GET',
      createUrl(`/machines/realtime/detail/${machineId}`).toStringUrl()
    );
    return response as any;
  }
};

export default RealTimeService;
